export default "__VITE_ASSET__c415409f__"